import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { ReceiptModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[Receipt] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[Receipt] Load items success', props<{ data: PaginationAdapter<ReceiptModel> }>());

// item
export const loadItem = createAction('[Receipt] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[Receipt] Load item success', props<{ item: ReceiptModel }>());
